"use client";
import { AutofitPageWrapper } from "@/components/AutofitPageWrapper";
import { Footer } from "@/components/footer";
import { About } from "@/components/page/about";
import { Assist } from "@/components/page/about/assist";
import { Business } from "@/components/page/about/business";
import { Contact } from "@/components/page/about/contact";
import { Zhengshu } from "@/components/page/about/zhengshu";
import { Why } from "@/components/page/sdwan/why";

export default function AboutPage() {
  return (
    <AutofitPageWrapper>
      <About />
      <Business />
      <Why />
      <Assist />
      <Zhengshu />
      <Contact />
      <Footer />
    </AutofitPageWrapper>
  );
}
